// Single source of truth for role handling + route permissions.
// Roles are normalized so 'admin'/'ADMIN'/' Admin ' → 'admin'; everything else
// ('staff', 'STAFF', 'rss', 'RSS Staff', unknown/missing) → 'staff'.

export const normalizeRole = (role) =>
  String(role || '').trim().toLowerCase() === 'admin' ? 'admin' : 'staff';

export const isAdmin = (user) => normalizeRole(user?.role) === 'admin';

// Routes an RSS staff account may open. Everything else is admin-only.
// Census and the main Schedule are STAFF-viewable (read-only; write APIs stay admin-only).
export const STAFF_ROUTES = new Set(['/', '/census', '/schedule', '/my-availability', '/my-schedule', '/profile']);

export const canAccessRoute = (user, path) => isAdmin(user) || STAFF_ROUTES.has(path);

export const readCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem('currentUser'));
  } catch (_) {
    return null;
  }
};

// Clear every cached credential/permission artifact (login, logout, account switch)
export const clearSession = () => {
  try {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('align_token');
    localStorage.removeItem('align31_alerts_read');
  } catch (_) { /* storage unavailable */ }
};
